const CaretBottomIcon = () => (
  <svg
    className="app"
    width="19"
    height="10"
    viewBox="0 0 19 10"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      fill="#51B94F"
      d="M0.661181 1.15738C0.820138 0.918762 1.05678 0.76101 1.31905 0.718827C1.58131 0.676645 1.84772 0.753488 2.05967 0.932453L9.45166 7.23046L16.8437 0.932453C17.0556 0.753488 17.322 0.676645 17.5843 0.718827C17.8465 0.76101 18.0832 0.918762 18.2421 1.15738C18.324 1.2762 18.3838 1.4123 18.4181 1.55761C18.4524 1.70292 18.4605 1.8545 18.4419 2.0034C18.4233 2.15229 18.3783 2.29546 18.3097 2.42445C18.2411 2.55344 18.1502 2.66563 18.0424 2.75438L10.2308 9.41227C10.0067 9.60382 9.73304 9.70752 9.45166 9.70752C9.17028 9.70752 8.89662 9.60382 8.6725 9.41227L0.860964 2.75438C0.75316 2.66563 0.662257 2.55344 0.593631 2.42445C0.525005 2.29546 0.480049 2.15229 0.461423 2.0034C0.442797 1.8545 0.450878 1.70292 0.485189 1.55761C0.5195 1.4123 0.579343 1.2762 0.661181 1.15738Z"
    />
  </svg>
);

export default CaretBottomIcon;
